export const DELIVERABLE_MODAL_WIDTH = 860;
